import { isAxiosError } from "axios";

type ErrorWithMessage = {
  message: string;
};

export function getMeaningfulErrorMessage(error: unknown, defaultMessage: string) {
  let message = toErrorWithMessage(error).message;
  console.log("getMeaningfulErrorMessage message", message);

  if (
    !message ||
    message === "undefined" ||
    message.includes("500") ||
    message.includes("status code")
  ) {
    console.log("original error message:", message);
    message = defaultMessage;
  }

  return message;
}

export function getErrorMessage(error: unknown) {
  return toErrorWithMessage(error).message;
}

function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
  if (isAxiosError(maybeError)) {
    const message = maybeError.response?.data.message;
    return new Error(String(message));
  }
  if (isErrorWithMessage(maybeError)) return maybeError;

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError));
  }
}

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as Record<string, unknown>).message === "string"
  );
}

// TODO: make a function that filters out meaningless errors like "rqeuest failed with status code 500"
// and instead use a passed in default message
